/** Shared slot subscription plans (Subscription page + Trading Accounts checkout). */

/** Single welcome promo for all tiers (checkout copy). */
export const WELCOME_PROMO_CODE = "WLCMBP";

/** Personal-broker welcome promo (Pricing / Subscription copy). */
export const PERSONAL_BROKER_PROMO_CODE = "WLCMPP";

export const SLOT_PLANS = [
  {
    id: "bronze",
    name: "Delta",
    period: "Monthly",
    cadence: "Billed every month",
    slots: "1 slot",
    priceUsdRegular: 50,
    priceUsdWelcome: 35,
    priceUsdPersonalBroker: 40,
    personalBrokerPriceLabel: "$40",
    price: "$35",
    regularPriceLabel: "$50",
    priceSuffix: "/ mo",
    months: 1,
    days: 30,
    accent: "border-amber-200/80 dark:border-amber-800/50",
    badge: null,
  },
  {
    id: "silver",
    name: "Gama",
    period: "Quarterly",
    cadence: "Billed every 3 months",
    slots: "1 slot",
    priceUsdRegular: 140,
    priceUsdWelcome: 98,
    priceUsdPersonalBroker: 112,
    personalBrokerPriceLabel: "$112",
    price: "$98",
    regularPriceLabel: "$140",
    priceSuffix: "/ quarter",
    months: 3,
    days: 90,
    accent: "border-slate-300 dark:border-white/15",
    badge: null,
  },
  {
    id: "gold",
    name: "Beta",
    period: "Semi-yearly",
    cadence: "Billed every 6 months",
    slots: "1 slot",
    priceUsdRegular: 270,
    priceUsdWelcome: 189,
    priceUsdPersonalBroker: 216,
    personalBrokerPriceLabel: "$216",
    price: "$189",
    regularPriceLabel: "$270",
    priceSuffix: "/ 6 mo",
    months: 6,
    days: 180,
    accent:
      "border-brand-400 ring-2 ring-brand-400/30 dark:border-brand-400 dark:ring-brand-400/25",
    badge: "Popular",
  },
  {
    id: "platinum",
    name: "Alpha",
    period: "Yearly",
    cadence: "Billed once per year",
    slots: "1 slot",
    priceUsdRegular: 550,
    priceUsdWelcome: 385,
    priceUsdPersonalBroker: 440,
    personalBrokerPriceLabel: "$440",
    price: "$385",
    regularPriceLabel: "$550",
    priceSuffix: "/ year",
    months: 12,
    days: 365,
    accent: "border-violet-300/90 dark:border-violet-500/40",
    badge: "Best value",
  },
];

export function getPlanById(id) {
  return SLOT_PLANS.find((p) => p.id === id) || null;
}

/** USD saved vs regular price with welcome offer (whole dollars). */
export function welcomeSavingsUsd(plan) {
  const r = Number(plan?.priceUsdRegular);
  const w = Number(plan?.priceUsdWelcome);
  if (!Number.isFinite(r) || !Number.isFinite(w) || w > r) return 0;
  return Math.round(r - w);
}

/** USD saved vs regular with personal-broker welcome pricing. */
export function personalBrokerSavingsUsd(plan) {
  const r = Number(plan?.priceUsdRegular);
  const w = Number(plan?.priceUsdPersonalBroker);
  if (!Number.isFinite(r) || !Number.isFinite(w) || w > r) return 0;
  return Math.round(r - w);
}

export function computeExpiryIsoDate(activatingYmd, monthsToAdd) {
  const [y, m, d] = activatingYmd.split("-").map(Number);
  const end = new Date(y, m - 1 + monthsToAdd, d);
  return end.toISOString().slice(0, 10);
}

export function planDaysForPlan(planOrId) {
  const plan =
    typeof planOrId === "string"
      ? getPlanById(planOrId)
      : planOrId;
  const days = Number(plan?.days);
  return Number.isFinite(days) && days > 0 ? days : 30;
}

export function addDaysToIsoDate(ymd, days) {
  const n = Number(days);
  if (!Number.isFinite(n) || n === 0) {
    return String(ymd || "").slice(0, 10);
  }
  const d = new Date(`${String(ymd || "").slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return String(ymd || "").slice(0, 10);
  d.setDate(d.getDate() + Math.trunc(n));
  return d.toISOString().slice(0, 10);
}

/** dd/mm/yyyy for extension preview */
export function formatExpiryDisplay(ymd) {
  const s = String(ymd || "").slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return s;
  return `${d}/${m}/${y}`;
}
